import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight, Coins } from 'lucide-react';
import { CheckoutStrip } from '@/components/trust/CheckoutStrip';

// ONE BALANCE (Studio Blueprint 02, home screen 4; owner 2026-10-16: the
// prices live on their own page). Home says what credits are in one line and
// sends people to /pricing for every pack and price. The pay sheet still
// offers packs at the moment of wanting, on top of the free preview.
export function CreditsBand() {
  const { t } = useTranslation();
  return (
    <section aria-labelledby="home-balance" data-testid="home-balance" className="py-10 sm:py-14">
      <div className="container mx-auto max-w-6xl px-4 md:px-8 xl:px-4">
        <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-[radial-gradient(120%_120%_at_0%_0%,rgba(244,190,82,0.16),transparent_55%),rgba(255,255,255,0.02)] p-6 sm:p-8">
          <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
            <div className="max-w-xl">
              <p className="eyebrow">{t('home.balanceEyebrow')}</p>
              <h2 id="home-balance" className="mt-2 font-display text-[1.5rem] font-bold leading-tight sm:text-[2rem]">{t('home.balanceTitle')}</h2>
              <p className="mt-2 text-pretty text-[15px] leading-relaxed text-muted-foreground">{t('home.balanceLead')}</p>
            </div>
            <Link
              to="/pricing"
              data-testid="home-balance-cta"
              className="inline-flex min-h-[48px] shrink-0 items-center justify-center gap-2 rounded-full bg-[linear-gradient(135deg,#F9D27E,#F4BE52_45%,#E4A43A)] px-6 text-[15px] font-bold text-[#10131a]"
            >
              <Coins className="h-4 w-4" aria-hidden />
              {t('home.balanceCta')}
              <ArrowRight className="h-4 w-4" aria-hidden />
            </Link>
          </div>
          <CheckoutStrip methods="packs" className="mt-6 sm:text-left [&_ul]:sm:justify-start" />
        </div>
      </div>
    </section>
  );
}
